import React from "react";
import { weightOrder, eventAttrBuilder, formatCurrencyDiff } from "./utility";

const PackVariableWeigth = (props) => {
  const {
    getSelectedWeight,
    currentWeights,
    currentPack,
    packIdx,
    item,
    handleChange,
    selectedState,
  } = props;

  const selectedWeight = getSelectedWeight(
    currentWeights[item],
    selectedState[item]
  );

  // v2 weight.description.text
  //   "description":{
  //   	"type": "description", // description || sugestion || offer, ((sugestion não aparece no resumo e em email))
  //   	"text": "texto"
  //   },
  // description: "text"  is deprecated

  return (
    <li className={"ic-" + item} key={item}>
      <div className="detail-radios">
        {currentWeights[item].map((weight, idx) => {
          const itemId = ["pack", packIdx, item, weight.id].join("_");
          const weightDiscount =
            (weight.discount || 0) - (selectedWeight.discount || 0);
          return (
            <div className="radio-item" key={itemId}>
              <input
                type="radio"
                id={itemId}
                name={["pack", packIdx, item].join("_")}
                checked={weight.id == selectedState[item]}
                onChange={handleChange(item, weight.id, weight.idInternal)}
              />
              <label
                htmlFor={itemId}
                {...eventAttrBuilder(
                  packIdx + 1,
                  currentPack.event.region,
                  currentPack.title,
                  3 + weightOrder.indexOf(item),
                  "n/a",
                  weight.title,
                  idx + 1
                )}
              >
                {weight.title}
                <span>
                  {formatCurrencyDiff(
                    weight.priceModifier -
                      selectedWeight.priceModifier -
                      weightDiscount
                  )}
                </span>
              </label>
            </div>
          );
        })}
      </div>

      {selectedWeight.description?.text && (
        <p
          className="detail-desc"
          dangerouslySetInnerHTML={{ __html: selectedWeight.description.text }}
        />
      )}
    </li>
  );
};

export default PackVariableWeigth;
